import PropTypes from 'prop-types';
import Cta from '../cta';

const FullwidthPromo = ({ headline, headlineElement, description, cta }) => {
	const headlineTypographyMap = {
		H1: { el: 'h1', className: 'typography--h1' },
		H2: { el: 'h2', className: 'typography--h2' },
	};
	const headlineTypography = headlineTypographyMap[headlineElement];
	const Headline = headlineTypography?.el || 'h1';

	return (
		<div className="fullwidth-promo">
			<div className="fullwidth-promo__content">
				<div className="fullwidth-promo__body">
					<Headline
						className={`typography ${headlineTypography?.className} typography--white`}
					>
						{headline}
					</Headline>
					<p className="typography typography--subtle-big typography--white">
						{description?.description}
					</p>
					<Cta {...cta} customClass="btn btn--white" />
				</div>
			</div>
		</div>
	);
};

FullwidthPromo.propTypes = {
	headline: PropTypes.string.isRequired,
	headlineElement: PropTypes.oneOf(['H1', 'H2']),
	description: PropTypes.shape({ description: PropTypes.string.isRequired }),
	cta: PropTypes.shape({
		title: PropTypes.string,
		link: PropTypes.string,
	}),
};

export default FullwidthPromo;
